import PropTypes from "prop-types";
import React from "react";
import Str from "shared/components/Str";

class Reactivate extends React.Component {
	static propTypes = {
		submitLogin: PropTypes.func.isRequired,
	};

	_submitLogin = (ev) => {
		ev.preventDefault();
		this.props.submitLogin();
	};

	render() {
		return (
			<form
				onSubmit={this._submitLogin}
				className="oknf oknf--gray login-form"
			>
				<div className="reactivate login-fields">
					<div className="login-fields-text">
						<Str>Welcome back!</Str> <br />
						<Str>Restore your account to continue meeting new people.</Str>
					</div>
				</div>

				<div className="login-actions">
					<button type="submit" className="login-actions-button">
						<Str>Restore account</Str>
					</button>
				</div>
			</form>
		);
	}
}

export default Reactivate;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/Reactivate.jsx